import { Box, Typography } from '@mui/material';
import { useRouteError } from 'react-router-dom';

export default function GlobalError() {
  const error = useRouteError();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '50px',
        width: '100vw',
        height: '100vh',
        flexFlow: 'column',
      }}
    >
      <img
        src="/brand/logo.svg"
        alt="Codemeta"
        style={{
          width: '100px',
        }}
      />
      <Typography variant="h4" gutterBottom>
        {error.status} {error.name}
      </Typography>

      <Typography variant="body1" gutterBottom>
        {error.message}
      </Typography>

      <Typography variant="body2" sx={{ fontFamily: 'monospace' }} gutterBottom>
        {error.stack}
      </Typography>
    </Box>
  );
}
